// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/EventListing/ReservedSeating/ReservedSeating.css
// module id = 1163
// module chunks = 0